const setStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

const getStorage = (key) => {
  let value = window.localStorage.getItem(key)
  try {
    value = JSON.parse(value)
  } catch (error) {
    console.error(error)
  }

  return value
}

const removeStorage = (key) => {
  window.localStorage.removeItem(key)
}

const clearStorage = () => {
  window.localStorage.clear()
}

const setSsionStorage = (key, value) => {
  window.sessionStorage.setItem(key, JSON.stringify(value))
}

const getSsionStorage = (key) => {
  let value = window.sessionStorage.getItem(key)
  try {
    value = JSON.parse(value)
  } catch (error) {
    console.error(error)
  }

  return value
}

const removeSsionStorage = (key) => {
  window.sessionStorage.removeItem(key)
}

const clearSsionStorage = () => {
  window.sessionStorage.clear()
}

export {
  setStorage,
  getStorage,
  removeStorage,
  clearStorage,
  setSsionStorage,
  getSsionStorage,
  removeSsionStorage,
  clearSsionStorage
}
